import { Box, LinearProgress } from "@mui/material";
import { DotsLoader, HeaderRupin, ImageRingLoader } from "../../common";
import { ParagraphText, UBButton, UBInput } from "../../../Libraries";
import { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../../../context/LanguageContext";
import TabAutoComplete from "../../../Libraries/TabAutoComplete";
import { createUser } from "../../../database/helpers/user";
import { uuid } from "../../../oscar-pos-core/constants";
import Cookies from "js-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../../context/AuthContext";

import { analytics, triggerLogEvent } from "../../../config/firebase";
import { NEW_CATEGORY_LIST } from "../../../constants";
import { Grid } from "@mui/material";
import styles from "./styles.module.css";
import FooterRupin from "../../common/FooterRupin";
import SelectOptionsmodule from "../NewSignUp/SelectOptionsmodule";
import { Sync } from "../../../SyncService";

const CreateBusiness = () => {
  const [I18n] = useContext(LanguageContext);
  const [businessName, setBusinessName] = useState("");
  const [businessCategory, setBusinessCategory] = useState("");
  const [selectedOption, setSelectedOption] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isSelectoptionSection, setIsSelectoptionSection] = useState(false);
  const [isCategoryOpen, setIsCategoryOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { setBusiness, setUser, user: existingUser } = useAuthContext();
  const variant = location?.state?.variant;
  const fromCashback = !!location?.state?.cashbackAmount;

  useEffect(() => {
    const phoneNumber = localStorage.getItem("phone_number");
    if (!existingUser && !phoneNumber) {
      navigate("/", { replace: true });
    }
  }, []);

  const onSubmit = async (e) => {
    const isTrue = Math.random() >= 0.5;
    const isVariantB = variant === "B";
    e.preventDefault();
    if (isVariantB && !isSelectoptionSection && !fromCashback) {
      setIsSelectoptionSection(true);
      return;
    }
    let user;
    if (existingUser) {
      user = existingUser;
    } else {
      let paramsForUser = {
        telco_network: "",
        phone_number: "",
        id: uuid(),
        is_active: true,
      };
      user = await createUser(paramsForUser);
      setUser(user);
    }

    let response = await user.createBusiness(
      businessName,
      false,
      false,
      businessCategory,
    );
    setBusiness(response);
    localStorage.setItem("business_id", response.id);
    if (response) {


      if (!user?.phone_number) {
        Cookies.set("tempUserId", user.id, { expires: 1 });
      }
      setIsLoading(true);
      if(user?.phone_number){
        Sync(user.phone_number, navigate)
      }
      triggerLogEvent(analytics, "login_business_created");
      setTimeout(
        () =>
          navigate(
            fromCashback
              ? "/BusinessOverview"
              : isVariantB
                ? selectedOption?.route || "/BusinessOverview"
                : isTrue
                  ? "/BusinessOverview"
                  : "/Accounts",
          ),
        2000,
      );
    }
  };

  return isLoading ? (
    <Box className={`${styles.onboardingForm} ${styles.onboardLoader}`}>
      <DotsLoader message={`Getting things ready for ${businessName}`} />
    </Box>
  ) : (
    <Box className={styles.signUpWrapper}>
      <Box
        className={`${styles.CreateBusinessContainer} onBoardingScreenWrapper`}
      >
        <HeaderRupin />
        {isSelectoptionSection ? (
          <SelectOptionsmodule
            setSelectedOption={setSelectedOption}
            selectedOption={selectedOption}
            onContinue={onSubmit}
          />
        ) : (
          <Grid container className="row justify-content-center h-100">
            <Grid item xs={12} md={6} className={styles.CreateBusinessGrid}>
              <form
                id="create_business_form"
                onSubmit={(e) => businessName && onSubmit(e)}
                className={styles.CreateBusinessForm}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && isCategoryOpen) e?.preventDefault();
                }}
              >
                <ParagraphText
                  className={"fontSize24 fontWeight500"}
                  id="enter_your_business_details"
                >
                  {I18n.enter_your_business_details}
                </ParagraphText>
                <Box mb={"34px"} />
                <UBInput
                  inputId="login_business_name"
                  placeholder={I18n.business_name_placeholder}
                  baseClassname={styles.businessInput}
                  value={businessName}
                  required
                  onChange={(e, value) => {
                    if (businessName.length === 0 && value.length >= 1) {
                      triggerLogEvent(analytics, "login_business_name");
                    }
                    setBusinessName(value);
                  }}
                  maxLength={50}
                  autoFocus={true}
                />
                {!!businessName && (
                  <TabAutoComplete
                    id="login_category"
                    list={NEW_CATEGORY_LIST}
                    placeholder={I18n.select_business_category}
                    label={I18n.select_business_category}
                    value={businessCategory}
                    handleSelect={(item) => {
                      setBusinessCategory(item?.value || "");
                      if (item?.value)
                        triggerLogEvent(analytics, "login_category", {
                          name: item?.value,
                        });
                    }}
                    onOpenChange={setIsCategoryOpen}
                  />
                )}
                <UBButton
                  id="business_name_continue"
                  title={I18n.continue}
                  type="submit"
                  disabled={!businessName}
                  className="ubPrimaryButton"
                />
              </form>
            </Grid>
          </Grid>
        )}
        <FooterRupin />
      </Box>
    </Box>
  );
};

export default CreateBusiness;
